export const environment = {
  production: false,
  translation: 'https://myaccount-stage.app.karcher.com/translation',
  configuration: 'https://myaccount-stage.app.karcher.com',
  backendURL: 'https://myaccount-stage.app.karcher.com/api/v1',
  backendURLV2: 'https://myaccount-stage.app.karcher.com/api/v2',
  mykaercher: 'https://myaccount-stage.app.karcher.com',
  corporateUrl: 'https://cms-stage.app.kaercher.com/',
  whitelist: ['myaccount-stage.app.karcher.com',"auth.test.karcher.com"],
  notFoundUrl: 'https://www.kaercher.com/int/404.html',
  recaptcha: {
    siteKey: '6Lf5nxsrAAAAAE9QwMKYxHlJw-akltsLFj_cVAQJ',
  },
  productRegistrationPages: {
    'INT': 'https://www.kaercher.com/int/qr-code-lp-h-g-app.html',
    'en-AE': 'https://www.kaercher.com/ae/qr-code-lp-h-g-app.html',
    'es-AR': 'https://www.kaercher.com/ar/qr-code-lp-h-g-app.html',
    'de-AT': 'https://www.kaercher.com/at/qr-code-lp-h-g-app.html',
    'en-AU': 'https://www.kaercher.com/au/qr-code-lp-h-g-app.html',
    'nl-BE': 'https://www.kaercher.com/be/qr-code-lp-h-g-app.html',
    'fr-BE': 'https://www.kaercher.com/be-fr/qr-code-lp-h-g-app.html',
    'bg-BG': 'https://www.kaercher.com/bg/qr-code-lp-h-g-app.html',
    'es-BO': 'https://www.kaercher.com/bo/qr-code-lp-h-g-app.html',
    'pt-BR': 'https://www.kaercher.com/br/qr-code-lp-h-g-app.html',
    'en-CA': 'https://www.kaercher.com/ca/qr-code-lp-h-g-app.html',
    'fr-CA': 'https://www.kaercher.com/ca-fr/qr-code-lp-h-g-app.html',
    'de-CH': 'https://www.kaercher.com/ch/qr-code-lp-h-g-app.html',
    'fr-CH': 'https://www.kaercher.com/ch-fr/qr-code-lp-h-g-app.html',
    'es-CL': 'https://www.kaercher.com/cl/qr-code-lp-h-g-app.html',
    'es-CO': 'https://www.kaercher.com/co/qr-code-lp-h-g-app.html',
    'cs-CZ': 'https://www.kaercher.com/cz/qr-code-lp-h-g-app.html',
    'de-DE': 'https://www.kaercher.com/de/qr-code-lp-h-g-app.html',
    'da-DK': 'https://www.kaercher.com/dk/qr-code-lp-h-g-app.html',
    'es-DO': 'https://www.kaercher.com/do/qr-code-lp-h-g-app.html',
    'es-EC': 'https://www.kaercher.com/ec/qr-code-lp-h-g-app.html',
    'et-EE': 'https://www.kaercher.com/ee/qr-code-lp-h-g-app.html',
    'es-ES': 'https://www.kaercher.com/es/qr-code-lp-h-g-app.html',
    'fi-FI': 'https://www.kaercher.com/fi/qr-code-lp-h-g-app.html',
    'fr-FR': 'https://www.kaercher.com/fr/qr-code-lp-h-g-app.html',
    'el-GR': 'https://www.kaercher.com/gr/qr-code-lp-h-g-app.html',
    'en-HK': 'https://www.kaercher.com/hk/qr-code-lp-h-g-app.html',
    'zh-HK': 'https://www.kaercher.com/hk-zh/qr-code-lp-h-g-app.html',
    'hr-HR': 'https://www.kaercher.com/hr/qr-code-lp-h-g-app.html',
    'hu-HU': 'https://www.kaercher.com/hu/qr-code-lp-h-g-app.html',
    'en-ID': 'https://www.kaercher.com/id/qr-code-lp-h-g-app.html',
    'en-IE': 'https://www.karcher.com/ie/en/home-and-garden/home-and-garden-app/qr-code-lp-handg-app-c1325',
    'en-IN': 'https://www.kaercher.com/in/qr-code-lp-h-g-app.html',
    'it-IT': 'https://www.kaercher.com/it/qr-code-lp-h-g-app.html',
    'en-KH': 'https://www.kaercher.com/kh/qr-code-lp-h-g-app.html',
    'ru-KZ': 'https://www.kaercher.com/kz/qr-code-lp-h-g-app.html',
    'lt-LT': 'https://www.kaercher.com/lt/qr-code-lp-h-g-app.html',
    'lv-LV': 'https://www.kaercher.com/lv/qr-code-lp-h-g-app.html',
    'ro-MD': 'https://www.kaercher.com/md/qr-code-lp-h-g-app.html',
    'ru-MD': 'https://www.kaercher.com/md-ru/qr-code-lp-h-g-app.html',
    'es-MX': 'https://www.kaercher.com/mx/qr-code-lp-h-g-app.html',
    'en-MY': 'https://www.karcher.com/my/en/legal/qr-code-lp-handg-app',
    'nl-NL': 'https://www.kaercher.com/nl/qr-code-lp-h-g-app.html',
    'no-NO': 'https://www.kaercher.com/no/qr-code-lp-h-g-app.html',
    'en-NZ': 'https://www.kaercher.com/nz/qr-code-lp-h-g-app.html',
    'pl-PL': 'https://www.kaercher.com/pl/qr-code-lp-h-g-app.html',
    'es-PE': 'https://www.kaercher.com/pe/qr-code-lp-h-g-app.html',
    'ro-RO': 'https://www.karcher.com/ro/ro/informatii-legale/inregistrare-handg-app',
    'sr-RS': 'https://www.kaercher.com/rs/qr-code-lp-h-g-app.html',
    'sv-SE': 'https://www.kaercher.com/se/qr-code-lp-h-g-app.html',
    'en-SG': 'https://www.kaercher.com/sg/qr-code-lp-h-g-app.html',
    'sl-SI': 'https://www.kaercher.com/si/qr-code-lp-h-g-app.html',
    'sk-SK': 'https://www.kaercher.com/sk/qr-code-lp-h-g-app.html',
    'th-TH': 'https://www.karcher.com/th/th/legal/qr-code-lp-handg-app ',
    'tr-TR': 'https://www.karcher.com/tr/tr/yasal-metinler/ev-and-bahce-uygulamasi-landing-page-qr-kodu',
    'zh-TW': 'https://www.kaercher.com/tw/qr-code-lp-h-g-app.html',
    'en-GB': 'https://www.karcher.com/gb/en/legal/qr-code-lp-handg-app',
    'en-US': 'https://www.kaercher.com/us/qr-code-lp-h-g-app.html',
    'vi-VN': 'https://www.kaercher.com/vn/qr-code-lp-h-g-app.html',
    'en-ZA': 'https://www.kaercher.com/za/qr-code-lp-h-g-app.html',
    'es-PA': 'https://www.karcher.com/pa/qr-code-lp-h-g-app.html',
    'en-KE': 'https://www.karcher.com/ke/qr-code-lp-h-g-app.html',
    'en-PH': 'https://www.karcher.com/ph/qr-code-lp-h-g-app.html',
    'az-AZ': 'https://www.karcher.com/az/qr-code-lp-h-g-app.html',
    'ka-GE': 'https://www.karcher.com/ge/qr-code-lp-h-g-app.html'
  }
};
